import { render, staticRenderFns } from "./CodePreferencesPanel.vue?vue&type=template&id=4c5e1f72&scoped=true&"
import script from "./CodePreferencesPanel.vue?vue&type=script&lang=js&"
export * from "./CodePreferencesPanel.vue?vue&type=script&lang=js&"
import style0 from "./CodePreferencesPanel.vue?vue&type=style&index=0&id=4c5e1f72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5e1f72",
  null
  
)

export default component.exports